import Controller from "./bustypes.controller";
import template from "./bustypes.html";

const bustypes = {
  template,
  controller: Controller,
};

export default bustypes;



// WEBPACK FOOTER //
// ./src/pages/bustypes/bustypes.component.js